import classNames from 'classnames';
import * as React from 'react';

export interface EnvironmentLabelProps {
    showEnvironmentLabel: boolean;
    environmentLabel: string;
}

export const EnvironmentLabel = (props: EnvironmentLabelProps) => {
    return (
        <>
            {props.showEnvironmentLabel && props.environmentLabel && (
                <div className={classNames('EnvironmentLabel', props.environmentLabel && `EnvironmentLabel--${props.environmentLabel.toLowerCase()}`)}>
                    {props.environmentLabel}
                </div>
            )}
            {!props.showEnvironmentLabel && props.environmentLabel && <div hidden>{props.environmentLabel}</div>}
        </>
    );
};
